import RekapitulasiNilaiPersediaan from "./RekapitulasiNilaiPersediaanUO";

export default RekapitulasiNilaiPersediaan;
